import {
  AuctionOrder,
  AuctionSalePurpose,
  AuctionCountryCode,
  ForestType,
  TaxonomicPlotMaturityCondition,
} from '@foros-fe/graphql'
import { enumToOption, SortOption } from '../../utils'

export type RangeValue = [number | null, number | null]
type FilterValues = RangeValue | string[] | SortOption | boolean | undefined
export type FilterState = {
  [key: string]: FilterValues
  price?: RangeValue
  area?: RangeValue
  volume?: RangeValue
  forestType?: string[]
  salePurpose?: string[]
  maturity?: string[]
  country?: string[]
  sortOrder?: SortOption
}

export const defaultFilterProps = {
  price: { min: null, max: null },
  area: { min: null, max: null },
  volume: { min: null, max: null },
  forestType: { options: enumToOption(ForestType) },
  salePurpose: { options: enumToOption(AuctionSalePurpose) },
  maturity: { options: enumToOption(TaxonomicPlotMaturityCondition) },
  country: { options: enumToOption(AuctionCountryCode) },
}

export const filterStateToQueryVariables = ({
  price,
  area,
  volume,
  forestType: forestTypeIn,
  salePurpose: salePurposeIn,
  maturity: maturityIn,
  sortOrder,
  country: countryCodeIn,
}: FilterState) => {
  const [priceCentsGteq, priceCentsLteq] =
    price?.map((value) => (value ? value * 100 : value)) ?? []
  const [areaGteq, areaLteq] = area ?? []
  const [volumeGteq, volumeLteq] = volume ?? []

  let order: AuctionOrder | undefined
  if (sortOrder) {
    const [property, direction] = sortOrder.value.split('/')

    order = { [property]: direction }
  }

  return Object.fromEntries(
    Object.entries({
      priceCentsGteq,
      priceCentsLteq,
      areaGteq,
      areaLteq,
      volumeGteq,
      volumeLteq,
      forestTypeIn,
      salePurposeIn,
      maturityIn,
      order,
      countryCodeIn,
    }).filter(([, value]) => typeof value !== 'undefined')
  )
}
